export default __webpack_public_path__ + "static/media/java.798ad9a1.png";